import { render, staticRenderFns } from "./PropertyPosition.vue?vue&type=template&id=7dd97ebc&"
import script from "./PropertyPosition.vue?vue&type=script&lang=ts&"
export * from "./PropertyPosition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports